import type { StaffUser } from './session'

const has = (u: StaffUser, ...roles: string[]) => u.roles.some((r) => roles.includes(r))

export const can = {
  manageSettings: (u: StaffUser) => has(u, 'owner', 'platform_admin'),
  managePriceBook: (u: StaffUser) => has(u, 'owner', 'platform_admin', 'commercial_manager'),
  manageUsers: (u: StaffUser) => has(u, 'owner', 'platform_admin'),
  managePeople: (u: StaffUser) => has(u, 'owner', 'platform_admin', 'hr_admin'),
}
